import React, { useCallback } from 'react'
import { Icon } from '@musinsa/mwms-ds'
import styled from 'styled-components'

interface Props {
  className?: string
  onClick: () => void
}

function InputResetButton({ className, onClick }: Props) {
  const handleClick = useCallback((e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation()
    onClick()
  }, [])

  return (
    <ResetButton onClick={handleClick} className={className}>
      <Icon name="circle-close" size={24} color="gray500" style={{ paddingLeft: '4px' }} />
    </ResetButton>
  )
}

const ResetButton = styled.div.attrs({ role: 'button' })`
  position: relative;
  top: -3px;
`

export default InputResetButton
